export const FETCH_DETAILS_START = "homepage/FETCH_DETAILS_START";
export const FETCH_DETAILS_COMPLETED = "homepage/FETCH_DETAILS_COMPLETED";
export const FETCH_DETAILS_FAILED = "homepage/FETCH_DETAILS_FAILED";
export const FETCH_MOST_CONTENT_LIST_START = "homepage/FETCH_MOST_CONTENT_LIST_START"
export const FETCH_MOST_CONTENT_LIST_COMPLETED = "homepage/FETCH_MOST_CONTENT_LIST_COMPLETED"
export const FETCH_MOST_CONTENT_LIST_FAILED = "homepage/FETCH_MOST_CONTENT_LIST_FAILED"
export const INIT_CONTENT_LIST_START = "homepage/INIT_CONTENT_LIST_START"
export const INIT_CONTENT_LIST_COMPLETED = "homepage/INIT_CONTENT_LIST_COMPLETED"
export const INIT_CONTENT_LIST_FAILED = "homepage/INIT_CONTENT_LIST_FAILED"